import React from 'react';
import { components, ControlProps } from 'react-select';
import { Icon } from '../../../Icon/Icon';

export const Control: React.FC<ControlProps<any, any>> = ({ children, ...rest }) => {
  return (
    <components.Control {...rest}>
      <Icon className="far fa-search" ml="8" mr="4" color="neutral.400" />

      {children}
    </components.Control>
  );
};
